import { Box, Checkbox, FlexLayout } from '@deity-io/portal-ui';
// import { JSONEditor } from 'components/JSONEditor';
import { IconButton } from 'components/IconButton/IconButton';
import { CreateEditMockDataModal } from 'components/Structures/CreateEditMockDataModal';
import { RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext, useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import type { IContainerChildrenProps } from 'utils';

interface ResponseBodyProps extends IContainerChildrenProps {
  locked?: boolean;
  // params: Record<string, string | number | undefined>;
  // url: string;
}
const ResponseBody: FC<ResponseBodyProps> = ({ locked }) => {
  const [state, setState] = useState<{ currentEditor: 'raw' | 'json'; isPopupOpen: boolean }>({
    currentEditor: 'raw',
    isPopupOpen: false
  });

  const ctx = useContext(RequestExplorerContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }
  let jsonData = {};
  if (state.currentEditor === 'json' && ctx.state.response?.body) {
    jsonData = JSON.parse(ctx.state.response.body);
  }

  return (
    <Box>
      <FlexLayout
        width="full"
        flexDirection="row"
        flexWrap="nowrap"
        alignItems="center"
        sx={{ paddingLeft: '10px', paddingRight: '10px' }}
      >
        <Checkbox
          label="raw"
          key="raw"
          checked={state.currentEditor === 'raw'}
          onChange={(e, checked) => {
            if (checked) {
              setState({ ...state, currentEditor: 'raw' });
            }
          }}
        />
        <Checkbox
          label="json"
          key="json"
          checked={state.currentEditor === 'json'}
          onChange={(e, checked) => {
            if (checked) {
              setState({ ...state, currentEditor: 'json' });
            }
          }}
        />
        <Box key="save" sx={{ marginLeft: 'auto', marginRight: '0' }}>
          {ctx.state.response?.body !== undefined && (
            <IconButton
              tooltip="Save to structure mock data."
              icon="save"
              onClick={() => {
                setState({ ...state, isPopupOpen: true });
              }}
            />
          )}
        </Box>
      </FlexLayout>
      {state.currentEditor === 'raw' ? (
        <Box
          width="100%"
          style={{
            minHeight: '100px',
            borderStyle: 'solid',
            borderColor: '#D4D4D4',
            borderWidth: '1px',
            paddingTop: '20px',
            paddingLeft: '10px',
            margin: '10px'
          }}
        >
          {ctx.state.response?.body}
        </Box>
      ) : (
        <JSONInput
          id="a_unique_id"
          viewOnly
          theme="light_mitsuketa_tribute"
          placeholder={jsonData}
          locale={locale}
          height="550px"
          width="100%"
        />
      )}
      {ctx.state.packageVersionUuid && ctx.state.response?.body && (
        <CreateEditMockDataModal
          isOpen={state.isPopupOpen}
          packageVersionUuid={ctx.state.packageVersionUuid}
          setOpenState={isOpen => {
            setState({ ...state, isPopupOpen: isOpen });
          }}
          onConfirm={() => {}}
          source={{ editor: 'requestExplorer' }}
          data={ctx.state.response.body}
          modelUuid={ctx.state.responseStructureUuid}
        />
      )}
    </Box>
  );
};

export default ResponseBody;
